/**
 * Utilitaires de normalisation de chaînes partagés entre les pages et composants.
 */

/**
 * Normalise une valeur de texte : minuscules, sans accents, sans espaces superflus.
 */
export const normalizeText = (s = '') =>
  String(s)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

/**
 * Normalise une valeur quelconque en chaîne minuscule sans espaces.
 */
export const normalize = (v) => (v || '').toString().trim().toLowerCase();

/**
 * Normalise le mode de compteur d'un matériel : retourne 'km' ou 'h'.
 */
export const normalizeModeCompteur = (value) =>
  String(value || 'h').toLowerCase() === 'km' ? 'km' : 'h';
